import styled from 'styled-components';

import Button from 'components/core/Button/Button';
import Icon from 'components/core/Icon/Icon';
import { Elevation } from 'models';

export const StyledButton = styled(Button)`
  width: 8rem;
  height: 5rem;
  margin: 0 1rem;
  box-shadow: ${({ theme }) => theme.elevation[Elevation.DEPTH9]};
`;

export const StyledIcon = styled(Icon)`
  font-size: 2.4rem;
`;
